//Importación de librerias
//---------------SIFA---------------
//Catalogos
import C003TiposDeActoReclamado from '../../../src/components/SIFA/Comun/Catalogos/C003TiposDeActoReclamado.vue'
import C005TiposDeCalificacion from '../../../src/components/SIFA/Comun/Catalogos/C005TiposDeCalificacion.vue'
import C004TiposDeEstadoDeAdmision from '../../../src/components/SIFA/Comun/Catalogos/C004TiposDeEstadoDeAdmision.vue'
import C011Adscripciones from '../../../src/components/SIFA/Comun/Catalogos/C011Adscripciones.vue'


//Creamos y asignamos los datos necesarios de SIFA
const sifa = [
  { Proviene: 'SIFA', Nombre: 'C003TiposDeActoReclamado', datos: C003TiposDeActoReclamado },
  { Proviene: 'SIFA', Nombre: 'C005TiposDeCalificacion', datos: C005TiposDeCalificacion },
  { Proviene: 'SIFA', Nombre: 'C004TiposDeEstadoDeAdmision', datos: C004TiposDeEstadoDeAdmision },
  { Proviene: 'SIFA', Nombre: 'C011Adscripciones', datos: C011Adscripciones }
]


//Exportamos los datos de SIFA
export default sifa;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/sifa.js
// module id = null
// module chunks = 